package org.example.zone360.models

import kotlinx.serialization.SerialName

@kotlinx.serialization.Serializable
data class DeleteSeasonPayload(
    val organization: String,
    @SerialName("seasonID")
    val seasonId: String,
)

@kotlinx.serialization.Serializable
data class DeleteSeasonResponse(
    val data: String? = null,
    val error: String? = null,
    val seasonID: String? = null,
    val message: String? = null,
)
